import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Service } from '~/types/models';

export interface DiscountPillProps {
  label: ReactNode;
  onClick?: () => void;
  className?: string;
  service?: Service;
}

export function DiscountPill({
  label,
  onClick,
  className,
  service,
}: DiscountPillProps) {
  return (
    <span
      className={cx(className, ['rounded-full text-xs py-1 px-4'], {
        'v2-bg-yellow-500 v2-text-neutral-900': service == undefined,
        'v2-bg-blue-500 v2-text-white': service === Service.VideoMessaging,
        'v2-bg-magenta-500 v2-text-white': service === Service.Testimonials,
      })}
      onClick={onClick}
    >
      {label}
    </span>
  );
}
